import styled from 'styled-components';
import banner from '~/assets/banners/banner-recuperar-senha.png';

export const Container = styled.div`
  background-color: #fff;
  min-height: 100dvh;
  h1 {
    color: #ff6900;
    font-size: 26px;
  }

  p {
    color: #8c8c8c;
    font-size: 14px;
    font-weight: 400;
    text-align: start;
  }

  .height {
    height: 37px;
  }

  .banner {
    background-image: url(${banner});
    height: 100px;
    width: 100%;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .btn-login {
    border-radius: 4px;
    background-color: #ff6900;
    color: #fff;
  }

  .bd-input {
    border: 1px solid #e1e1e1;

    input {
      width: 100%;
      flex: 1;
      background: transparent;
      border: 0;
      color: #5a5a5a;
      transition-duration: 0.2s;
      font-weight: 500;

      ::placeholder {
        color: #5a5a5a;
      }
    }
  }

  svg:not(.g-icon) path {
    fill: #5a5a5a;
  }
`;
